import Icon from "@cloudscape-design/components/icon"
import { Link } from "react-router-dom"
import ProtocolAlert from "../../../components/ProtocolAlert"
import UploadButton from "../../../components/UploadButton"

interface ProtocolFailedStateProps {
  /**
   * Study ID for navigation links.
   */
  studyId: string
  /**
   * Error message from the failed extraction.
   */
  error?: string
  /**
   * Whether an upload is currently in progress.
   */
  uploading: boolean
  /**
   * Error message from a failed upload attempt.
   */
  uploadError: string | null
  /**
   * Callback to trigger file picker.
   */
  onUploadClick: () => void
}

/**
 * Displayed when protocol PDF extraction fails.
 *
 * Shows the error message and provides recovery options: - "Try Again" to re-upload a PDF - "Create
 * Manually" to bypass extraction and enter data directly.
 */
const ProtocolFailedState = ({
  studyId,
  error,
  uploading,
  uploadError,
  onUploadClick,
}: ProtocolFailedStateProps) => (
  <div className="protocol-failed">
    <span className="protocol-failed-icon">
      <Icon name="status-negative" size="large" />
    </span>
    <h3>Extraction Failed</h3>
    <p>{error || "An error occurred during protocol extraction."}</p>

    {uploadError && <ProtocolAlert message={uploadError} />}

    <div className="protocol-failed-actions">
      <Link
        to={`/studies/${studyId}/protocol/edit`}
        className="acdiv-btn-primary inline-flex items-center gap-1.5"
      >
        <Icon name="edit" size="normal" /> Create Protocol
      </Link>
      <UploadButton
        uploading={uploading}
        onClick={onUploadClick}
        label="Upload Protocol PDF"
        icon={<Icon name="upload" size="normal" />}
      />
    </div>
  </div>
)

export default ProtocolFailedState
